export const accountContentEnum = {
  ACCOUNT_SETTINGS: 'account_settings',
  ACCOUNT_ADDRESS: 'account_address',
  ACCOUNT_INVOICE: 'account_invoice'
}
